module.exports = __webpack_public_path__ + "static/media/access_223.403f8325.ico";